import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiPython,
  DiJava,
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiGit,
} from "react-icons/di";
import {
  SiExpress,
  SiDocker,
  SiKubernetes,
  SiNumpy,
  SiPandas,
  SiScikitlearn,
  SiTensorflow,
  SiPytorch,
  SiWireshark,
} from "react-icons/si";
import { GiRadarSweep } from "react-icons/gi"; // for Nmap
import { RiShieldKeyholeLine } from "react-icons/ri"; // for Metasploit
import { FaLinux } from "react-icons/fa"; // for Kali Linux

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* Programming Languages */}
      <Col xs={4} md={2} className="tech-icons"><DiPython /></Col>
      <Col xs={4} md={2} className="tech-icons"><DiJava /></Col>
      <Col xs={4} md={2} className="tech-icons"><DiJavascript1 /></Col>

      {/* Frameworks */}
      <Col xs={4} md={2} className="tech-icons"><DiReact /></Col>
      <Col xs={4} md={2} className="tech-icons"><DiNodejs /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiExpress /></Col>

      {/* Databases */}
      <Col xs={4} md={2} className="tech-icons"><DiMongodb /></Col>

      {/* Deployment */}
      <Col xs={4} md={2} className="tech-icons"><SiDocker /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiKubernetes /></Col>

      {/* ML Libraries */}
      <Col xs={4} md={2} className="tech-icons"><SiNumpy /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiPandas /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiScikitlearn /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiTensorflow /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiPytorch /></Col>

      {/* Cybersecurity Tools */}
      <Col xs={4} md={2} className="tech-icons"><RiShieldKeyholeLine /></Col> {/* Metasploit */}
      <Col xs={4} md={2} className="tech-icons"><GiRadarSweep /></Col> {/* Nmap */}
      <Col xs={4} md={2} className="tech-icons"><FaLinux /></Col> {/* Kali Linux */}
      <Col xs={4} md={2} className="tech-icons"><SiWireshark /></Col> {/* Wireshark */}

      {/* Version Control */}
      <Col xs={4} md={2} className="tech-icons"><DiGit /></Col>
    </Row>
  );
}

export default Techstack;
